export function Dispatcher() {
    return (<>
        <div className="view-model left">
            <p>This will be released in version 1.2.0 sorry for the inconvenience.</p>
        </div>
        </>
        )
        }